module.exports = __webpack_public_path__ + "img/worth_5.bf6e3603.png";